import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { DialogHeader } from "components/Parts/Atoms/DialogHeader";
import React from "react";
import styles from "./Confirm.module.scss";
import { useConfirmHooks } from "./hooks";
import { ConfirmProps } from "./interfaces";

export const Confirm = React.memo((props: ConfirmProps) => {
  const { busy, onOkClick } = useConfirmHooks(props);

  return (
    <>
      <Dialog
        style={props.style}
        className={`${props.className} ${styles.dialog}}`}
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="confirm-title"
        aria-describedby="confirm-description"
        fullWidth
        slotProps={{
          paper: { className: styles.dialogPaper },
          backdrop: { className: styles.backdrop }
        }}
      >
        <DialogHeader id="confirm-title" icon={<QuestionMarkIcon />} />
        <DialogContent id="confirm-description">{props.content}</DialogContent>
        <DialogActions className={styles.actions}>
          <Button
            variant="contained"
            className={styles.cancelButton}
            disabled={busy}
            onClick={props.onCloseClick}
          >
            キャンセル
          </Button>
          <Button
            variant="contained"
            className={styles.okButton}
            disabled={busy}
            onClick={onOkClick}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
});
